import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BASE_API } from "../Config/Config";

const WarehouseOccupancy = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState([]);

  useEffect(() => {
    fetchstatistics();
  }, []);

  const fetchstatistics = async () => {
    try {
      const response = await fetch(`${BASE_API}/apis/statistics_show.php`, {
        method: "POST",
        body: new FormData(),
      });

      const result = await response.json();

      if (result.status === "success") {
        setData(result.data || []);
        setTotal(result.total || null);
      } else {
        setData([]);
        setTotal([]);
        console.log(result.message || "No data found");
      }

    } catch (err) {
      console.error("Fetch Error:", err);
      console.log("Failed to fetch warehouse data");
    }
  };

  const today = new Date().toLocaleDateString("en-GB");

  const getRowColor = (value) => {
    if (value <= 70) return "#bef5cb";
    if (value <= 90) return "#f0b593";
    return "#e77c87";
  };

  let rowIndex = 1;

  return (
    <div className="container my-5">
      <div className="text-center mb-4" data-aos="fade-up">
        <h3 className="text-uppercase" >{t('tnwcChennai')}</h3>
        <h5 className="fw-bold mt-2">
          {t('warehouseOccupancyPosition', { date: today })}
        </h5>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-hover border-danger text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>{t('sNo')}</th>
              <th>{t('location')}</th>
              <th>{t('totalCapacity')}</th>
              <th>{t('occupancy')}</th>
              <th>{t('available')}</th>
              <th>{t('occupancyPercent')}</th>
              <th>{t('availablePercent')}</th>
            </tr>
          </thead>
          <tbody>
            {data && Object.keys(data).length > 0 ? (
              Object.entries(data).map(([regionName, regionData], rIndex) => (
                <React.Fragment key={rIndex}>
                  {/* Region Row */}
                  <tr>
                    <td colSpan="7" className="fw-bold text-white text-center" style={{ backgroundColor: "#3d3d3d" }}>
                      {regionName} Region
                    </td>
                  </tr>

                  {/* Warehouse Rows */}
                  {regionData.warehouses.map((warehouse, wIndex) => (
                    <tr key={wIndex}>
                      {[
                        rowIndex++,
                        warehouse.wh_name,
                        warehouse?.capacity_summary?.total_capacity,
                        warehouse?.capacity_summary?.occupancy,
                        warehouse?.capacity_summary?.available,
                        warehouse?.capacity_summary?.occupancy_percentage + " %",
                        warehouse?.capacity_summary?.available_percentage + " %"
                      ].map((cell, i) => (
                        <td
                          key={i}
                          className={i === 1 ? "text-start" : ""}
                          style={{
                            backgroundColor: getRowColor(
                              warehouse?.capacity_summary?.occupancy_percentage
                            )
                          }}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}

                  {/* Optional: Region Total Row */}
                  <tr className="fw-bold" >
                    <td className="text-dark" style={{ backgroundColor: "#e7e7e7" }} colSpan="2">Total {regionName} Region </td>
                    <td className="text-dark" style={{ backgroundColor: "#e7e7e7" }} >{regionData.region_total.total_capacity}</td>
                    <td className="text-dark" style={{ backgroundColor: "#e7e7e7" }} >{regionData.region_total.occupancy}</td>
                    <td className="text-dark" style={{ backgroundColor: "#e7e7e7" }} >{regionData.region_total.available}</td>
                    <td className="text-dark" style={{ backgroundColor: "#e7e7e7" }} >{regionData.region_total.occupancy_percentage} %</td>
                    <td className="text-dark" style={{ backgroundColor: "#e7e7e7" }} >{regionData.region_total.available_percentage} %</td>
                  </tr>

                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  {t('noWarehouseDataFound')}
                </td>
              </tr>
            )}
          </tbody>
          {total && (
            <tfoot className="fw-bold" style={{ backgroundColor: "#3e4253ff" }} data-aos="zoom-up" data-aos-delay="400">
              <tr>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }} colSpan="2">
                  {t('total')}
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_capacity}
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_occupancy}
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_available}
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_occupancy_percentage} %
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_available_percentage} %
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

export default WarehouseOccupancy;